import { render, staticRenderFns } from "./Thome.vue?vue&type=template&id=a10a368a&scoped=true&"
import script from "./Thome.vue?vue&type=script&lang=js&"
export * from "./Thome.vue?vue&type=script&lang=js&"
import style0 from "./Thome.vue?vue&type=style&index=0&id=a10a368a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a368a",
  null
  
)

export default component.exports